import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel", "clearable"];
import { compare, isDateInRange } from '../../../utils/SimpleDate';
import { syntheticEvent } from '../../../utils/SyntheticEvent';
import { Tooltip } from '../../Tooltip';
import { lazyEval } from '../../../utils/lazyEval';
import { CalendarFooterButton } from './CalendarFooterButton';
import { Flex } from '../../../../components/Flex/Flex';
import { filterProps } from '../../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CalendarFooterButtons = _ref => {
  let {
      clearLabel = 'Today',
      max,
      maxValidationMessage,
      min,
      minValidationMessage,
      onChange,
      today,
      todayLabel = 'Today',
      clearable: __clearable = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const todayButtonDisabled = !isDateInRange(today, min, max);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const comparedDates = compare(today, min) === -1;
  return /*#__PURE__*/_jsxs(Flex, Object.assign({}, domProps, tokenProps, {
    justifyContent: "space-between",
    marginBlockStart: "400",
    marginBlockEnd: "500",
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: todayButtonDisabled && lazyEval(comparedDates && minValidationMessage ? minValidationMessage : maxValidationMessage || ''),
      children: /*#__PURE__*/_jsx(CalendarFooterButton, {
        "data-action": "today",
        paddingInline: "1000",
        disabled: todayButtonDisabled,
        onMouseDown: e => {
          e.preventDefault();
        },
        onClick: () => {
          if (!onChange) return null;
          onChange(syntheticEvent(today));
        },
        children: lazyEval(todayLabel)
      })
    }), /*#__PURE__*/_jsx(CalendarFooterButton, {
      "data-action": "clear",
      paddingInline: "1000",
      onMouseDown: e => {
        e.preventDefault();
      },
      onClick: () => {
        if (!onChange) return null;
        onChange(syntheticEvent(null));
      },
      children: lazyEval(clearLabel)
    })]
  }));
};